import * as React from 'react';
import { Fragment } from 'react';
import { compose, setDisplayName, withHandlers } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { ReportSettings, ReportSettingsChangeHandler } from 'logic/reports/ReportSettings';
import { RunOnSchedule } from './runOnSchedule/RunOnSchedule';
import { FadeCollapse } from 'ui/transitions';
import { ReportType, UtcTime } from 'types';
import * as moment from 'moment-timezone';
import { getTimezoneOffsetCalculator } from 'selectors/serverSelectors';
import { State } from 'reducers';
import { connect } from 'react-redux';

import './ScheduleSection.css';

export type OwnProps = {
    reportType: ReportType;
    reportSettings: Readonly<ReportSettings>;
    onChange: ReportSettingsChangeHandler;
};

const styles: { [name: string]: React.CSSProperties } = {
    indented: {
        marginLeft: '2em',
    },
    schedules: {
        position: 'relative',
        marginTop: '1em',
    },
};

type Props = OwnProps & RecomposeProps & TranslateProps;
const RawScheduleSection = ({ reportType, reportSettings, onChange, handleClickOnSchedule, t }: Props) =>
    <Fragment>
        <div>
            <label>
                <input
                    type="checkbox"
                    id="run-report-on-schedule"
                    checked={ reportSettings.scheduleEnabled }
                    onChange={ handleClickOnSchedule }
                />
                { t('Schedule_Enabled') }
            </label>
        </div>
        <div style={ styles.schedules }>
            <FadeCollapse
                visible={ reportSettings.scheduleEnabled }
                duration={ 200 }
                height="23em"
            >
                <RunOnSchedule reportSettings={ reportSettings } onChange={ onChange }/>
            </FadeCollapse>
        </div>
    </Fragment>
;

type StateProps = {
    tzOffsetCalculator: (t: UtcTime) => number;
};
type RecomposeProps = {
    handleClickOnSchedule: React.ChangeEventHandler<HTMLInputElement>;
};

const mapStateToProps = (state: State) => ({
    tzOffsetCalculator: getTimezoneOffsetCalculator(state),
});

export const ScheduleSection = compose<Props, OwnProps>(
    setDisplayName('ScheduleSection'),
    translate(),
    connect<StateProps, {}, {}>(mapStateToProps),
    withHandlers<OwnProps & StateProps, RecomposeProps>({
        handleClickOnSchedule: ({ onChange, tzOffsetCalculator }) => () => {
            onChange(reportSettings => {
                const enabled = !reportSettings.scheduleEnabled;
                reportSettings = reportSettings.setScheduleEnabled(enabled);
                if (enabled) {
                    if (reportSettings.scheduleRangeStart === 0) {
                        const m = moment.utc().startOf('day').utcOffset(tzOffsetCalculator(Date.now()), true);
                        reportSettings = reportSettings.setScheduleRangeStart(m.valueOf());
                    }
                    if (reportSettings.scheduleRangeEnd === 0) {
                        reportSettings = reportSettings.setScheduleRangeEnd(ReportSettings.endNever);
                    }
                }
                return reportSettings;
            });
        },
    }),
)(RawScheduleSection);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/schedule/ScheduleSection.tsx